"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.PayoutTransactionCategory = exports.PayoutTransactionDisputeStatus = exports.CompleteStripeAuthError = exports.BankAccountStatus = exports.StripePayoutInterval = exports.PayoutInterval = exports.StripePayoutStatus = exports.StripeCapabilityStatus = exports.StripeAccountAction = void 0;
var StripeAccountAction;
(function (StripeAccountAction) {
    StripeAccountAction["AccountOnboarding"] = "account_onboarding";
    StripeAccountAction["AccountUpdate"] = "account_update";
})(StripeAccountAction || (exports.StripeAccountAction = StripeAccountAction = {}));
var StripeCapabilityStatus;
(function (StripeCapabilityStatus) {
    StripeCapabilityStatus["Active"] = "active";
    StripeCapabilityStatus["Inactive"] = "inactive";
    StripeCapabilityStatus["Pending"] = "pending";
})(StripeCapabilityStatus || (exports.StripeCapabilityStatus = StripeCapabilityStatus = {}));
var StripePayoutStatus;
(function (StripePayoutStatus) {
    StripePayoutStatus["paid"] = "paid";
    StripePayoutStatus["pending"] = "pending";
    StripePayoutStatus["inTransit"] = "in_transit";
    StripePayoutStatus["canceled"] = "canceled";
    StripePayoutStatus["failed"] = "failed";
})(StripePayoutStatus || (exports.StripePayoutStatus = StripePayoutStatus = {}));
var PayoutInterval;
(function (PayoutInterval) {
    PayoutInterval["Monthly"] = "Monthly";
    PayoutInterval["Weekly"] = "Weekly";
    PayoutInterval["Daily"] = "Daily";
    PayoutInterval["Manual"] = "Manual";
})(PayoutInterval || (exports.PayoutInterval = PayoutInterval = {}));
var StripePayoutInterval;
(function (StripePayoutInterval) {
    StripePayoutInterval["monthly"] = "monthly";
    StripePayoutInterval["weekly"] = "weekly";
    StripePayoutInterval["daily"] = "daily";
    StripePayoutInterval["manual"] = "manual";
})(StripePayoutInterval || (exports.StripePayoutInterval = StripePayoutInterval = {}));
var BankAccountStatus;
(function (BankAccountStatus) {
    BankAccountStatus["Errored"] = "Errored";
    BankAccountStatus["Verified"] = "Verified";
})(BankAccountStatus || (exports.BankAccountStatus = BankAccountStatus = {}));
var CompleteStripeAuthError;
(function (CompleteStripeAuthError) {
    CompleteStripeAuthError["ImpossibleToCreateStripeAccount"] = "ImpossibleToCreateStripeAccount";
})(CompleteStripeAuthError || (exports.CompleteStripeAuthError = CompleteStripeAuthError = {}));
var PayoutTransactionDisputeStatus;
(function (PayoutTransactionDisputeStatus) {
    PayoutTransactionDisputeStatus["Pending"] = "pending";
    PayoutTransactionDisputeStatus["Reversal"] = "reversal";
})(PayoutTransactionDisputeStatus || (exports.PayoutTransactionDisputeStatus = PayoutTransactionDisputeStatus = {}));
var PayoutTransactionCategory;
(function (PayoutTransactionCategory) {
    PayoutTransactionCategory["Charge"] = "charge";
    PayoutTransactionCategory["Refund"] = "refund";
    PayoutTransactionCategory["Transfer"] = "transfer";
})(PayoutTransactionCategory || (exports.PayoutTransactionCategory = PayoutTransactionCategory = {}));
